<style>
.v-input--selection-controls {
  margin-top: 0;
}

@font-face {
  font-family: "Bliss 2";
  src: url(./fonts/Bliss2/Bliss2R.otf) format("opentype");
}

@font-face {
  font-family: "Bliss 2";
  font-weight: bold;
  src:  url(./fonts/Bliss2/Bliss2B.otf) format("opentype");
} 

body, .v-application {
      font-family: "Bliss 2", Helvetica, Arial;
    }

h1, h2, h3, h4, h5, h6 {
      font-family: "Bliss 2", Helvetica, Arial;
      font-weight: bold;
     }  

  .v-application button.primary:hover {
      background-color: #FFF !important;
      color: #DB4132 !important;
      border: 1px solid #DB4132;
      transition: .2s;
    }

    .hasValidationErrorIcon .v-input__prepend-inner {
      display: none !important;
    }

    .hasValidationErrorIcon.error--text .v-input__prepend-inner {
      display: inline-block !important;
    }

    .hasValidationErrorIcon.error--text .v-label {
      left: -25px !important;
    }
</style>

<template>
  <v-app>
    <v-app-bar app color="primary" dark>
      <!--<v-app-bar-nav-icon
        @click.stop="sidebarMenu = !sidebarMenu"
      ></v-app-bar-nav-icon>-->
      <v-toolbar-title><h2>SEND YOUR ITEM</h2> </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon>
        <v-img src="./assets/logo.png" width="50" height="50" contain @click="redirectToIntro()"></v-img>
      </v-btn>
    </v-app-bar>
    <!--<v-navigation-drawer
      v-model="sidebarMenu"
      app
      :permanent="sidebarMenu"
      :mini-variant.sync="mini"
      color="primary"
    >
      <v-list dense class="secondary">
        <v-list-item>
          <v-list-item-content>
            <v-img
              src="./assets/logo.png"
              width="100"
              height="100"
              contain
            ></v-img>
            <v-list-item-title></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
      <v-list>
        <v-list-item
          v-for="item in items"
          :key="item.title"
          link
          :to="item.href"
        >
          <v-list-item-icon>
            <v-icon color="white">{{ item.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="white--text">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>-->
    <v-main>
      <v-container class="px-4 py-0 fill-height" fluid>
        <v-row class="fill-height">
          <v-col>
            <transition name="fade">
              <router-view></router-view>
            </transition>
          </v-col>
        </v-row>
      </v-container>
      <v-footer color="primary" class="py-3">
        <span class="overline white--text"
          >&copy; {{ year }} MaltaPost |
          <span v-if="!isMobile()">All rights reserved | </span>Version
          {{ version }}</span
        >
      </v-footer>
    </v-main>
  </v-app>
</template>

<script>
import properties from "./assets/properties.json";
import router from './router'

export default {
  name: "App",

  components: {},

  data: () => ({
    sidebarMenu: false,
    items: [{ title: "Home", href: "/", icon: "mdi-home" }],
    year: new Date().getFullYear(),
    version: properties.ServiceComponentVersion,
    mini: false,
    toggleMini: false,
  }),
  methods: {
    isMobile() {
      if (window.innerWidth <= 800) {
        return true;
      } else {
        return false;
      }
    },
    redirectToIntro: function() {
      router.push('/');
    },
  },
  created: function() {
    this.sidebarMenu = !this.isMobile();
  },
  mounted() {
    this.$store.dispatch("getSettings");
  },
};
</script>
